import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { HeaderFeature } from '@app/src/common/header';
import { FooterFeature } from '@app/src/common/footer';
import { FormForgotPassword } from '@app/src/common/session/components/FormForgotPassword';
import { FormNewPassword } from '@app/src/common/session/components/FormNewPassword';
import { ModalErrorFeature } from '@app/src/common/modalError';
import { isClientEnv } from '@app/src/utils/validations';
import { FooterWrapper } from './styled';

const isClient = isClientEnv();

export const RecoveryPassword: React.FC = () => {
  const location = useLocation();
  const [ isNewPassword, setIsNewPassword ] = useState(false);
  let query = null;
  let hash = null;

  useEffect(() => {
    if (isClient && 'URLSearchParams' in window) {
      query = new URLSearchParams(location.search);
      hash = query.get('hash');
      if (hash) {
        setIsNewPassword(true);
      }
    }
  }, []);
  
  return (
    <React.Fragment>
      <HeaderFeature navBar />
        {
          isNewPassword ?
            <FormNewPassword />
          :
            <FormForgotPassword />
        }
      <ModalErrorFeature />
      <FooterWrapper>
        <FooterFeature isDisplay={true} />
      </FooterWrapper>
    </React.Fragment>
)};
